export const FEATURE_ENABLED_FOR_USER = "0";
export const FEATURE_NOT_ENABLED_FOR_USER = "1";
export const FAILED_TO_PARSE_VALUE = "2";
export const FAILED_TO_PARSE_REVENUE = "3";
export const INVALID_CLIENT_ENGINE = "4";
export const INVALID_DEFAULT_DECIDE_OPTIONS = "5";
export const INVALID_DECIDE_OPTIONS = "6";
export const NOT_ACTIVATING_USER = "7";
export const PARSED_REVENUE_VALUE = "8";
export const PARSED_NUMERIC_VALUE = "9";
export const SAVED_USER_VARIATION = "10";
export const SAVED_VARIATION_NOT_FOUND = "11";
export const SHOULD_NOT_DISPATCH_ACTIVATE = "12";
export const SKIPPING_JSON_VALIDATION = "13";
export const TRACK_EVENT = "14";
export const USER_MAPPED_TO_FORCED_VARIATION = "15";
export const USER_HAS_NO_FORCED_VARIATION = "16";
export const USER_RECEIVED_DEFAULT_VARIABLE_VALUE = "17";
export const FEATURE_NOT_ENABLED_RETURN_DEFAULT_VARIABLE_VALUE = "18";
export const VARIABLE_NOT_USED_RETURN_DEFAULT_VARIABLE_VALUE = "19";
export const USER_RECEIVED_VARIABLE_VALUE = "20";
export const VALID_DATAFILE = "21";
export const VALID_USER_PROFILE_SERVICE = "22";
export const VARIATION_REMOVED_FOR_USER = "23";
export const VALID_BUCKETING_ID = "24";
export const EVALUATING_AUDIENCE = "25";
export const AUDIENCE_EVALUATION_RESULT = "26";
export const MISSING_ATTRIBUTE_VALUE = "27";
export const UNEXPECTED_TYPE_NULL = "28";
export const UPDATED_OPTIMIZELY_CONFIG = "29";
export const ADDING_AUTHORIZATION_HEADER_WITH_BEARER_TOKEN = "30";
export const MAKING_DATAFILE_REQ_TO_URL_WITH_HEADERS = "31";
export const RESPONSE_STATUS_CODE = "32";
export const SAVED_LAST_MODIFIED_HEADER_VALUE_FROM_RESPONSE = "33";
export const USER_HAS_NO_FORCED_VARIATION_FOR_EXPERIMENT = "34";
export const INVALID_EXPERIMENT_KEY_INFO = "35";
export const IGNORE_CMAB_CACHE = "36";
export const RESET_CMAB_CACHE = "37";
export const INVALIDATE_CMAB_CACHE = "38";
export const CMAB_CACHE_HIT = "39";
export const CMAB_CACHE_ATTRIBUTES_MISMATCH = "40";
export const CMAB_CACHE_MISS = "41";
export const ODP_IDENTIFY_NOT_DISPATCHED = "42";
export const messages = [
    "Feature %s is enabled for user %s.",
    "Feature %s is not enabled for user %s.",
    "Failed to parse event value \"%s\" from event tags.",
    "Failed to parse revenue value \"%s\" from event tags.",
    "Invalid client engine passed: %s. Defaulting to node-sdk.",
    "Provided default decide options is not an array.",
    "Provided decide options is not an array. Using default decide options.",
    "Not activating user %s for experiment %s.",
    "Parsed revenue value \"%s\" from event tags.",
    "Parsed event value \"%s\" from event tags.",
    "Saved user profile for user \"%s\".",
    "User %s was previously bucketed into variation with ID %s for experiment %s, but no matching variation was found.",
    "Experiment %s is not in \"Running\" state. Not activating user.",
    "Skipping JSON schema validation.",
    "Tracking event %s for user %s.",
    "Set variation %s for experiment %s and user %s in the forced variation map.",
    "User %s is not in the forced variation map.",
    "User \"%s\" is not in any variation or rollout rule. Returning default value for variable \"%s\" of feature flag \"%s\".",
    "Feature \"%s\" is not enabled for user %s. Returning the default variable value \"%s\".",
    "Variable \"%s\" is not used in variation \"%s\". Returning default value.",
    "Got variable value \"%s\" for variable \"%s\" of feature flag \"%s\"",
    "Datafile is valid.",
    "Valid user profile service provided.",
    "Variation mapped to experiment %s has been removed for user %s.",
    "BucketingId is valid: \"%s\"",
    "Starting to evaluate audience \"%s\" with conditions: %s.",
    "Audience \"%s\" evaluated to %s.",
    "Audience condition %s evaluated to UNKNOWN because no value was passed for user attribute \"%s\".",
    "Audience condition %s evaluated to UNKNOWN because a null value was passed for user attribute \"%s\".",
    "Updated Optimizely config to revision %s (project id %s)",
    "Adding Authorization header with Bearer Token",
    "Making datafile request to url %s with headers: %s",
    "Response status code: %s",
    "Saved last modified header value from response: %s",
    "No experiment %s mapped to user %s in the forced variation map.",
    "Experiment key %s is not in datafile. It is either invalid, paused, or archived.",
    "Ignoring CMAB cache for user %s and rule %s.",
    "Resetting CMAB cache for user %s and rule %s.",
    "Invalidating CMAB cache for user %s and rule %s.",
    "Cache hit for user %s and rule %s.",
    "CMAB cache attributes mismatch for user %s and rule %s, fetching new decision.",
    "Cache miss for user %s and rule %s.",
    "ODP identify event is not dispatched (fewer than 2 valid identifiers)."
];
//# sourceMappingURL=log_message.gen.js.map